<div class="page-container">
  <app-sidebar></app-sidebar>

  <main class="main-content">
    <div class="page-header">
      <div class="header-content">
        <h1 class="page-title">Settings</h1>
        <p class="page-subtitle">Configure payment methods and application settings</p>
      </div>
    </div>

    <!-- Messages -->
    <div *ngIf="successMessage" class="alert alert-success">{{ successMessage }}</div>
    <div *ngIf="errorMessage" class="alert alert-error">{{ errorMessage }}</div>

    <!-- Payment Methods -->
    <div class="content-card">
      <h2 class="card-title">Payment Methods</h2>
      <p class="section-description">Configure which payment methods are available for session purchases in the mobile app.</p>

      <div *ngIf="isLoading" class="loading-state">
        <div class="spinner"></div>
        <p>Loading payment methods...</p>
      </div>

      <div *ngIf="!isLoading" class="methods-list">
        <div *ngFor="let method of paymentMethods" class="method-card">
          <div class="method-header">
            <div class="method-info">
              <span class="method-icon">
                <svg *ngIf="method.name === 'Cash'" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/>
                </svg>
                <svg *ngIf="method.name !== 'Cash'" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"/>
                </svg>
              </span>
              <span class="method-name">{{ method.name }}</span>
            </div>
            <label class="toggle-switch">
              <input type="checkbox" [(ngModel)]="method.isActive" />
              <span class="toggle-slider"></span>
            </label>
          </div>

          <!-- Account link (for InstaPay) -->
          <div *ngIf="method.name === 'InstaPay'" class="method-body">
            <label>InstaPay Link</label>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="method.accountLink"
              placeholder="https://ipn.eg/S/..."
            />
          </div>

          <div class="method-footer">
            <button class="btn btn-primary btn-sm" (click)="saveMethod(method)" [disabled]="isSaving[method.id]">
              <span *ngIf="!isSaving[method.id]">Save</span>
              <span *ngIf="isSaving[method.id]">Saving...</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>
